<template>
  <div id="hostpanel" class="container row text-center">
    <div v-if="isMobile" class="col-md-12 col-lg-6">
      <PieChart
      :data="host_country"
      :innerRadius="50"
      :outerRadius="140"
      :padAngle="0.05"
      :colorScheme="'schemeAccent'"
      :isMobile="isMobile"
      :height="700" />
    </div>
    <div v-else class="col-md-12 col-lg-6">
      <PieChart
      :data="host_country"
      :innerRadius="50"
      :outerRadius="140"
      :padAngle="0.05"
      :colorScheme="'schemeAccent'"
      :isMobile="isMobile" />
    </div>
    <div class="col-md-12 col-lg-6 d-lg-flex flex-lg-column justify-content-center">
      <b>Almost all of the IPL matches hosted by India</b>
      <p>IPL 2009 was played in South Africa because of the Lok Sabha elections in 2009 which
          were going on in the country and the unavailability of the security forces for the matches
          prompted BCCI to either shift the dates of IPL or cancel it but they came up with a brilliant
          idea of having the IPL in South Africa and eventually it turned out to be a huge success.</p>
      <p>Even during the 2014 Lok Sabha elections the first phase of the IPL was conducted
          in UAE and even in UAE the IPL became a instant hit because of its popularity.</p>
    </div>
	</div>
</template>

<script>
import host_country from "../assets/host_country.json";

export default {
  name: "HostCountryPanel",
  components: {
    PieChart: () => import("./PieChart.vue")
  },
  data() {
    return {
      host_country,
      isMobile: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener(
        "orientationchange",
        this.detectOrientationChange
      );
    });
  },
  created() {
    this.detectOrientationChange();
  },
  methods: {
    detectOrientationChange() {
      // switch (window.orientation) {
      //   case 0:
      //     // landscape
      //     this.isMobile = true;
      //     break;
      //   default:
      //     // portrait
      //     this.isMobile = false;
      //     break;
      // }

      if (window.screen.width > 767) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    }
  }
};
</script>

<style >
#hostpanel {
  margin-bottom: 20px;
  border-bottom: 1px grey solid;
}
</style>
